/*!

=========================================================
* Argon Dashboard React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import {
Button,
CustomInput,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  CardTitle,
    CardFooter,
  Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap";
import Swal from 'sweetalert2'
// core components
import Header from "components/Headers/Header";
import '../../assets/css/profile.css'
import { useRef, useEffect, useState } from "react";
import { updateSettings } from "redux/Settings/SettingsAction";
import { useDispatch } from "react-redux";
import { connect } from "react-redux";
import Select from 'react-select';
import {customDropdown} from "util/reactCustomStyles";


const Settings = (props) => {
  

  const dispatch = useDispatch();
  

  useEffect(() => {
    if(props.updateSettings.loading){
      Swal.fire({
        allowOutsideClick : false,
        didOpen: () => {
          Swal.showLoading()
          
        }
      });
  
    }
    else{
        if(props.updateSettings.settings.length && typeof props.updateSettings.error === "undefined" && props.updateSettings.done){
            
            Swal.fire({
                title: 'Success!',
                text: 'Successfully update settings!',
                icon : 'success',
                timer: 3000      
            }
            )
            
        }
        
        else if(typeof props.updateSettings.error !== "undefined" && props.updateSettings.done){
            
            Swal.fire({
                title:'Failed!',
                text:'Failed to update settings!',
                icon :'error',
                timer: 3000 
                }
            )
        }
        }
    }, [props.updateSettings])


    useEffect(() => {
      
    
      if(props.fetchSettings.settings.length && typeof props.fetchSettings.error === "undefined"){
        setSelectedApplicationCycle(props.fetchSettings.settings[0].currentApplicationCycle)
      }

    }, [props.fetchSettings])
    



    const handleClickUpdate = (e) => {
        e.preventDefault();

 
        const data = {
            currentApplicationCycle : selectedApplicationCycle
    
        }
        
        dispatch(updateSettings(data))

    }
        

    


    const [selectedApplicationCycle, setSelectedApplicationCycle] = useState("");
    const [cycles, setCycles] = useState([]);
    const [touched, setTouched] = useState(false);

  
    useEffect(() => {
        const currentYear = new Date().getFullYear();
        const newCycles = Array.from({ length: 6 }, (_, i) => {
        const start = currentYear + i;
        return `${start}-${start + 1}`;
        });
        setCycles([...new Set(newCycles.map((cycle) => {return {value:cycle, label: cycle}}))]);

    }, []);

    const handleApplicationCycleChange = (selectedOption) => {
        setSelectedApplicationCycle(selectedOption.value);
        setTouched(true);
    };


  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7 mb-5" fluid>
        <Row >
          <Col className="order-xl-1" xl="12">
            <Card className=" shadow">
              <CardHeader className=" ">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">Settings</h3>
                  </Col>
               
                </Row>
              </CardHeader>
              <CardBody>
                <Form>
                  <h6 className="heading-small text-muted mb-4">
                    Global Settings
                  </h6>
                  <div className="pl-lg-4">
                    <Row>
                      <Col md="6">
        
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="phone-number"
                          >
                            Current Application Cycle
                          </label>
                          <Select 
                              placeholder="Select Current Application Cycle" 
                              options={cycles}
                              styles={customDropdown}  
                              onChange={handleApplicationCycleChange}
                              menuPortalTarget={document.body}
                              value={cycles.find((option) => option.value === selectedApplicationCycle)}
                              
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>                  

                  
                </Form>
              </CardBody>
              <CardFooter className="text-right ">

                <Button color="primary" type='submit' onClick={(e) => handleClickUpdate(e)}>
                      Save
                </Button>
       

              </CardFooter>
            </Card>
          </Col>
        </Row>
      </Container>      
    
    </>
  );
};

const mapStateToProps = state  => {
  return {
    updateSettings : state.updateSettings,
    fetchSettings : state.fetchSettings
  }
    
}

export default connect(mapStateToProps)(Settings);
